import { useQuery } from '@tanstack/react-query';
import {
  getWasteLogs, type GetWasteLogsParams 
} from '../api';

export function useWasteLogs(siteId: string, filters?: Omit<GetWasteLogsParams, 'siteId'>) {
  return useQuery({
    queryKey: ['waste-logs', siteId, filters],
    queryFn: () => getWasteLogs({
      siteId,
      ...filters 
    }),
    enabled: Boolean(siteId),
  });
}
